import { Button, Glyphicon, Overlay, Popover } from 'react-bootstrap';
import { MentorAssignTable } from './styles';
import { ICounselor } from './models';
import { Component } from 'react';
import { PopoverWrapper } from '@nkr/components/overlay-menu-button';

interface IProps {
    selectedUserId: number,
    users: ICounselor[],
    onSelect: (id: number) => void,
    onToggle: (show: boolean) => void,
}

interface IState {
    show: boolean,
    selectedUser: ICounselor,
}

class MentorDropDown extends Component<IProps, IState> {
    readonly state: IState = {
        show: false,
        selectedUser: null
    };

    componentDidMount = () => {
        let selectedUser = this.props.users.find((user) => user.id === this.props.selectedUserId);

        this.setState({
            selectedUser
        });
    }

    elem: any;

    setElem = (elem: any) => this.elem = elem;

    onHide = () => {
        this.setState({ show: false });
    };

    onToggle = () => {
        this.setState({
            show: !this.state.show
        });

        if (this.props.onToggle) {
            this.props.onToggle(!this.state.show);
        }
    };

    handleSelect = (user: ICounselor) => {
        this.setState({
            selectedUser: user
        }, () => {
            this.props.onSelect(user.id);
        });
    };

    handleUnassign = () => {
        this.setState({
            selectedUser: null
        }, () => {
            this.props.onSelect(0);
        });
    }

    render = () => {
        const title = this.state.selectedUser
            ? ` ${this.state.selectedUser.lastName}, ${this.state.selectedUser.firstName}`
            : '- Assign Mentor - ';

        const bsStyle = '';
        const bsSize = 'xs';
        const placement = 'bottom';
        const includeArrow = true;
        const width = 351;
        const includeCaret = true;

        return (
            <div ref={this.setElem}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button block bsStyle={bsStyle} bsSize={bsSize} onClick={this.onToggle} title={''}>{title} {includeCaret ? <span className='caret'></span> : null}</Button>
                    {this.props.selectedUserId > 0 &&
                        <div style={{ paddingLeft: 3 }}>
                            <Glyphicon glyph='remove' title='Click here to unassign...' onClick={this.handleUnassign} />
                        </div>
                    }
                </div>
                <Overlay
                    show={this.state.show}
                    target={() => this.elem}
                    onHide={this.onHide}
                    placement={placement}
                    containerPadding={20}
                    rootClose>
                    <PopoverWrapper includeArrow={includeArrow} width={width} className='overlay-menu-button' onClick={this.onHide}>
                        <div style={{ width: '350px', maxHeight: '300px', overflowY: 'auto', paddingTop: 0 }}>
                            <MentorAssignTable bordered striped hover condensed style={{ marginBottom: 0 }}>
                                <thead>
                                    <tr>
                                        <th>Mentor</th>
                                        <th title='Assignment Limit'>LIM</th>
                                        <th title="Today's Assignments">NEW</th>
                                        <th title='To-Do Cases'>F/U</th>
                                        <th title='All Active Cases'>ALL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.users.map((user) => (
                                        <tr
                                            key={user.id}
                                            onClick={() => this.handleSelect(user)}
                                            className={`dropdown-row ${this.state.selectedUser?.id === user.id ? 'selected' : ''}`}
                                        >
                                            <td>{user.lastName}, {user.firstName}</td>
                                            <td className='text-center'>{user.donorConnectCaseLoad}</td>
                                            <td className='text-center' style={{ borderLeft: 'solid #ddd 1px' }}>{user.assignedTodayCount}</td>
                                            <td className='text-center' style={{ borderLeft: 'solid #ddd 1px' }}>{user.followUpCount}</td>
                                            <td className='text-center' style={{ borderLeft: 'solid #ddd 1px' }}>{user.activeCaseCount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </MentorAssignTable>
                        </div>
                    </PopoverWrapper>
                </Overlay>
            </div>
        );
    }
}

export default MentorDropDown;